var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { DateTime, Info } from 'luxon';
import classNames from 'classnames';
import styles from './calendarDays.module.scss';
import { uppercaseFirstLetter } from '../../../../../shared/helpers/stringHelpers';
import { useUpdate } from '../../../../../shared/hooks/useLifecycle';
import { IDENTIFIER_DATETIME_INPUT_CALENDAR_DAY_ITEM, } from 'src/ui/components/Input/DateTimeInput/constants';
export var CalendarDays = function (props) {
    var startDate = props.startDate, endDate = props.endDate, currentMonth = props.currentMonth, currentYear = props.currentYear, onChange = props.onChange;
    var _a = useState(startDate || null), startInterval = _a[0], setStartInterval = _a[1];
    var _b = useState(endDate || null), endInterval = _b[0], setEndInterval = _b[1];
    var now = DateTime.now();
    var dayInMonth = DateTime.local(currentYear, currentMonth).daysInMonth;
    var daysPosition = Array.from({ length: dayInMonth }, function (item, index) { return DateTime.local(currentYear, currentMonth, index + 1).weekday; });
    var weekDays = Info.weekdays('short');
    var dayShortClassName = classNames(styles.dayWrapper, styles.dayLabelItem);
    useUpdate(function () {
        setStartInterval(startDate);
        setEndInterval(endDate);
    }, [startDate, endDate]);
    var handleDayClick = function (e, day) {
        var date = DateTime.local(currentYear, currentMonth, day);
        if (endInterval || !startInterval) {
            onChange({ startDate: date, endDate: null });
        }
        else if (startInterval) {
            var dateIsBeforeStart = date.toMillis() - startDate.toMillis() < 0;
            if (dateIsBeforeStart) {
                onChange({ startDate: date, endDate: null });
            }
            else {
                onChange({ startDate: startDate, endDate: date });
            }
        }
    };
    var dayClassName = function (day) {
        var _a;
        var startIntervalMilli = DateTime.isDateTime(startInterval) ? startInterval === null || startInterval === void 0 ? void 0 : startInterval.toMillis() : 0;
        var endIntervalMilli = DateTime.isDateTime(endInterval) ? endInterval === null || endInterval === void 0 ? void 0 : endInterval.toMillis() : 0;
        var dayTargetMilli = DateTime.local(currentYear, currentMonth, day).toMillis();
        var isToday = day === now.day && currentMonth === now.month && currentYear === now.year;
        var isStart = startInterval
            ? day === startInterval.day && currentMonth === startInterval.month && currentYear === startInterval.year
            : false;
        var isInterval = startInterval && endInterval ? dayTargetMilli > startIntervalMilli && dayTargetMilli < endIntervalMilli : false;
        var isEnd = endInterval
            ? day === endInterval.day && currentMonth === endInterval.month && currentYear === endInterval.year
            : false;
        return classNames(styles.dayWrapper, styles.dayItem, (_a = {},
            _a[styles.todayItem] = isToday,
            _a[styles.startInterval] = isStart,
            _a[styles.inInterval] = isInterval,
            _a[styles.endInterval] = isEnd,
            _a[styles.uniqueDay] = (startInterval && isStart && !endInterval) || (endInterval && isEnd && !startInterval) || (isStart && isEnd),
            _a));
    };
    return (_jsxs("div", __assign({ className: styles.calendarDaysWrapper }, { children: [weekDays.map(function (day, index) { return (_jsx("div", __assign({ className: dayShortClassName }, { children: uppercaseFirstLetter(day.substring(0, 3)) }), index)); }), daysPosition.map(function (item, index) {
                return (_jsx("div", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT_CALENDAR_DAY_ITEM, className: dayClassName(index + 1), style: { gridColumn: item }, onClick: function (e) { return handleDayClick(e, index + 1); } }, { children: index + 1 }), "".concat(item, "-").concat(index)));
            })] })));
};
